import { errorToastMessage, toastMessage } from "../../utils/toast";
import {
  setData,
  setEnabledSections,
  setLoading,
  setSaveLoader,
  setToggleLoader,
  setUrlsData,
} from "../reducers/appCustomizationSlice";
import { AppThunk } from "../store";
import http from "../../utils/http";
import { DateTime } from "luxon";
import { AxiosResponse } from "axios";
import {
  formatHomePageData,
  formatSaveCustomization,
} from "../../utils/appCustomization";

const defaultStateData = [
  {
    key: "key-1",
    enabled: true,
    defaultIcon: {
      url: "",
      previewUrl: "",
    },
    activeIcon: {
      url: "",
      previewUrl: "",
    },
    text: "",
    connector: "",
    position: "extreme_left",
  },
  {
    key: "key-2",
    enabled: true,
    defaultIcon: {
      url: "",
      previewUrl: "",
    },
    activeIcon: {
      url: "",
      previewUrl: "",
    },
    text: "",
    connector: "",
    position: "left",
  },
  {
    key: "key-3",
    enabled: true,
    defaultIcon: {
      url: "",
      previewUrl: "",
    },
    activeIcon: {
      url: "",
      previewUrl: "",
    },
    text: "",
    connector: "",
    position: "center",
  },
  {
    key: "key-4",
    enabled: true,
    defaultIcon: {
      url: "",
      previewUrl: "",
    },
    activeIcon: {
      url: "",
      previewUrl: "",
    },
    text: "",
    connector: "",
    position: "right",
  },
  {
    key: "key-5",
    enabled: true,
    defaultIcon: {
      url: "",
      previewUrl: "",
    },
    activeIcon: {
      url: "",
      previewUrl: "",
    },
    text: "",
    connector: "",
    position: "extreme_right",
  },
];

const splashDummyData = [
  {
    key: "splash",
    label: "Splash",
    image: {
      url: "",
      previewUrl: "",
    },
  },
  {
    key: "brand_attribution",
    label: "Brand Attribution",
    image: {
      url: "",
      previewUrl: "",
    },
  },
];

const menuDummyData = [
  {
    key: "icon1",
    enabled: true,
    text: "",
    connector: "",
  },
  {
    key: "icon2",
    enabled: false,
    text: "",
    connector: "",
  },
  {
    key: "icon3",
    enabled: true,
    text: "",
    connector: "",
  },
  {
    key: "icon4",
    enabled: false,
    text: "",
    connector: "",
  },
];

const urlsDummyData = [
  {
    key: "url1",
    url: "https://www.mahalocare.com/user/homepage",
    date: DateTime.now().toFormat("MMM dd, yyyy"),
  },
  {
    key: "url2",
    url: "https://www.mahalocare.com/education/learn-more",
    date: DateTime.now().minus({ days: 1 }).toFormat("MMM dd, yyyy"),
  },
  {
    key: "url3",
    url: "https://www.mahalocare.com/tools/scan-now",
    date: DateTime.now().minus({ days: 2 }).toFormat("MMM dd, yyyy"),
  },
  {
    key: "url4",
    url: "https://www.mahalocare.com/health/dashboard",
    date: DateTime.now().minus({ days: 3 }).toFormat("MMM dd, yyyy"),
  },
];

export const fetchCustomizationData =
  (studyId: string | undefined, selectedCategory: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const res: AxiosResponse = await http.get(
        // `/admin/study/${studyId}/app-configurables/mobile/home`
        `/study/${studyId}/dashboard`
      );
      if (selectedCategory === "splash") {
        dispatch(setData(splashDummyData));
      } else if (selectedCategory === "home" && res.data.data) {
        let formattedData: any[] = [];
        if (!res.data.data) {
          formattedData = formatHomePageData(res.data.data);
        } else {
          formattedData = defaultStateData;
        }
        dispatch(setData(formattedData));
        const enabled = formattedData.filter((item: any) => item.enabled);
        dispatch(setEnabledSections(enabled));
      } else if (selectedCategory === "menu") {
        dispatch(setData(menuDummyData));
        const enabled = menuDummyData.filter((item: any) => item.enabled);
        dispatch(setEnabledSections(enabled));
      }
    } catch (e) {
      errorToastMessage(e as Error);
    } finally {
      dispatch(setLoading(false));
    }
  };

export const fetchUrlsData =
  (studyId: string | undefined): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setLoading(true));
      await http.get(`/study/${studyId}/dashboard`);
      dispatch(setUrlsData(urlsDummyData));
    } catch (e) {
      errorToastMessage(e as Error);
    } finally {
      dispatch(setLoading(false));
    }
  };

export const saveCustomizationData =
  (studyId: string | undefined, selectedCategory: string): AppThunk =>
  async (dispatch, getState) => {
    try {
      dispatch(setSaveLoader(true));
      const data = getState().appCustomization.data;
      const formattedData = formatSaveCustomization(data);
      const res: AxiosResponse = await http.post(
        `/admin/study/${studyId}/app-configurables/mobile/home`,
        formattedData
      );
      toastMessage("success", res.data.message);
      dispatch(setToggleLoader());
      dispatch(setLoading(true));
    } catch (e) {
      errorToastMessage(e as Error);
    } finally {
      dispatch(setLoading(false));
      dispatch(setSaveLoader(false));
    }
  };
